import React from "react";
import { connect } from "react-redux";
import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Comments from "./Comments";

function DetailedProduct(props) {
  const product = props.allProducts.filter(
    (item) => Number(item.id) === Number(props.match.params.id)
  );

  return (
    <div>
      {product.length === 0 ? (
        <h1 className="text-center my-3">Product Not Found</h1>
      ) : (
        product.map((item, i) => {
          return (
            <div key={item.id} className="container mx-auto my-3">
              <Card
                className="shadow-lg mx-auto "
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  backgroundColor: "#f4f4f4",
                }}
              >
                {" "}
                <div className="row">
                  <div className="col-lg-5 p-5 d-flex justify-content-center">
                    <div className="my_deal_img">
                      <img
                        className="img-fluid mx-auto shadow-lg"
                        src={item.image}
                        alt="..."
                      />
                    </div>
                  </div>
                  <div className="col-lg-7 p-5">
                    <div className="shadow-lg h-100 py-3">
                      <h4 className="ps-3">{item.title}</h4>
                      <hr
                        style={{
                          border: "1px solid red",
                          marginTop: "-5px",
                        }}
                      />
                      <p className="px-3 text-muted">{item.description} </p>
                      <h3 className="px-3 m-0">
                        Rs.{item.discounted_price} &nbsp;
                        <span className="text-decoration-line-through text-muted h6">
                          Rs.{item.selling_price}
                        </span>
                      </h3>
                      <p className="px-3" style={{ fontSize: "10px" }}>
                        Save Rs. {item.selling_price - item.discounted_price}{" "}
                      </p>
                      <div className="px-3 ">
                        {props.cart.find(
                          (citem) => Number(citem.id) === Number(item.id)
                        ) ? (
                          <Button
                            variant="dark"
                            onClick={() => {
                              props.removeFromCart(item.id);
                            }}
                          >
                            Remove From Cart
                          </Button>
                        ) : (
                          <Button
                            variant="dark"
                            onClick={() => {
                              props.addToCart(item);
                            }}
                          >
                            Add To Cart
                          </Button>
                        )}
                        <div className="d-block d-sm-none"></div>
                        <Button
                          variant="dark"
                          className="ms-0 ms-sm-5 mt-2 mt-sm-0"
                          onClick={() => {
                            props.addToCart(item);
                          }}
                        >
                          <Link
                            to="/cart"
                            className="text-decoration-none text-white"
                          >
                            BUY NOW
                          </Link>
                        </Button>
                      </div>
                      <div className="mt-4 px-3">
                        <h6>Available Offer</h6>
                        <ul style={{ fontSize: "13px" }}>
                          <li>
                            Bank Offer 5% Unlimited Cahback On Axis Bank Credits
                          </li>
                          <li>
                            Special Price Get Extra Rs.3000 Off (Price Inclusive
                            Of Discount
                          </li>
                          <li>
                            No Cost EMI Rs.1534/month. Standard EMI Also
                            Available
                          </li>
                          <li>
                            Partner Offer Rs2000 Gift Card On Evry 1000th
                            Transaction With A New Visa ebit/Credit Card
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-3 py-3">
                  <Comments {...props} />
                </div>
              </Card>
            </div>
          );
        })
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    allProducts: state.products,
    cart: state.cart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (val) => dispatch({ type: "ADD_TO_CART", payload: val }),
    removeFromCart: (val) =>
      dispatch({ type: "REMOVE_FROM_CART", payload: val }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailedProduct);
